<template>
  <div class="loading-spinner">
    <i class="fa fa-spinner fa-spin fa-3x fa-fw" />
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  data() {
    return {}
  }
}
</script>

<style scoped>
  .content {
    float: left; /* Add this */
    width: 650px;
    height: 500px;
    background-color: #F5CF8E;
  }
</style>

